"use strict";

angular.module('PatientApp').controller('AppRootCtrl', ['$scope', '$log', '$rootScope', '$state', '$stateParams', '$translate', '$timeout', '$window', '$q', '_', 'NavService', 'AuthService', 'OverlayService', 'ContextHelperService', 'BillsService', 'smoothScroll', 'Url2ObjService', 'ExperimentService', 'PatientUsersService', 'ErrorsService', 'Config', 'AutoLogoutService', 'LoadingIndicatorService', 'Compass', 'endpoints', 'Subdomain', 'BrandingConfigService', 'EstimatesService', '$filter', 'VueEventTransmitter', 'BrowserInfoService', 'VuexStore', 'LinkedAccountsService', '$interval', function ($scope, $log, $rootScope, $state, $stateParams, $translate, $timeout, $window, $q, _, NavService, AuthService, OverlayService, ContextHelperService, BillsService, smoothScroll, Url2ObjService, ExperimentService, PatientUsersService, ErrorsService, Config, AutoLogoutService, LoadingIndicatorService, Compass, endpoints, Subdomain, BrandingConfigService, EstimatesService, $filter, VueEventTransmitter, BrowserInfoService, VuexStore, LinkedAccountsService, $interval) {
  var _authChecked = false,
      _returnState = null,
      _returnStateParams = {},
      _appStateSettled = false,
      NUM_MILLISECONDS_BEFORE_EBILL_OPENED = 3271,
      // calculated as the mean + 4 standard deviations time user agents spend on wallet
  _handleSuccessfulGetAccountBill = function _handleSuccessfulGetAccountBill() {
    // we got the bill!
    ExperimentService.sendSuccess('showDueDateandAmountonEbill');
    ExperimentService.sendSuccess('financingInEbill');

    if ($state.params.goto === 'plans' || $state.params.goto === 'financing') {
      if (VuexStore.state.BillsStore.currentBill.getProviderDetails().features.indexOf('newWalletAccountPaymentFlow') > -1) {
        $state.go('app.home.accounts-summary.account-payment.amount', {
          accountId: VuexStore.state.BillsStore.currentBill.accountInfo.accountId,
          providerId: VuexStore.state.BillsStore.currentBill.getProviderDetails().id
        });
      } else {
        $state.go('app.payment.start', $state.params);
      }
    } else {
      $state.go('app.bill-summary');
    }
  };

  if (Config.env === 'test') {
    $window.vueEventTransmitter = VueEventTransmitter;
  }

  VuexStore.commit('setIsAngular', true);

  var finishRegistration = function finishRegistration(data) {
    // we know the user doesn't exist, but we need to force refresh XSRF-TOKEN
    return PatientUsersService.fetchUser().finally(function () {
      var deferred = $q.defer();

      var callBackFunction = function callBackFunction() {
        deferred.resolve();
        return $q.when();
      };

      VueEventTransmitter.$emit('myChartSSO:showFinishRegistration', data, callBackFunction);
      return deferred.promise;
    });
  };

  $translate((Subdomain ? 'whitelabel.' : '') + 'landing.title').then(function (translation) {
    $scope.title = translation;
  }); // ---------------------
  // Resources needed to make up the UI
  // ---------------------

  $scope.nav = NavService;
  $scope.overlay = OverlayService;
  $scope.auth = AuthService;
  $scope.contextHelper = ContextHelperService;
  $scope.version = Config.version;
  $scope.releaseFolder = Config.releaseFolder;
  $scope.loadingIndicator = LoadingIndicatorService;
  $scope.currentYear = new Date().getFullYear();
  VuexStore.commit('setShowLoading', true);
  VuexStore.commit('setShowSSOHeader', false);
  $rootScope.VuexStore = VuexStore;
  $rootScope.VueEventTransmitter = VueEventTransmitter;
  $rootScope.newContent = false;

  if ($window.sessionStorage.getItem('conversationId')) {
    VuexStore.commit('setIsChatSessionActive', true);
  } else {
    VuexStore.commit('setIsChatSessionActive', false);
  }

  $scope.subdomain = Subdomain;
  var now = new Date().getTime();
  $scope.whiteLabelCssUrl = endpoints.providers.theme.url + '/' + $scope.subdomain + '?nocache=' + now;

  if ($scope.subdomain) {
    var head = document.head;
    var styleLink = document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.href = $scope.whiteLabelCssUrl;
    head.appendChild(styleLink);
  }

  $scope.brandUrl = endpoints.providers.brand.url + '/' + $scope.subdomain + '?nocache=' + now;

  $scope.getFaviconUrl = function (size) {
    if ($scope.subdomain) {
      return endpoints.providers.favicon.url + '/' + $scope.subdomain + '?&size=' + size + '&nocache=' + now;
    } else {
      return '/favicon-' + size + 'x' + size + '.png';
    }
  };

  if ($scope.subdomain) {
    BrandingConfigService.getConfig().then(function (config) {
      VuexStore.dispatch('setBrandingConfig', config); // need this temporarily until we can port the Loyal code

      $rootScope.brandingConfig = VuexStore.state.AppStore.brandingConfig;
    }).catch(function (err) {
      $log.error('Unable to retreive branding config for subdomain ' + Subdomain + '. ' + err);
    });
  } // document.referrer


  $scope.referrer = document.referrer;
  VuexStore.commit('setInitialHistoryLength', $window.history.length); // ---------------------
  // Patientco Values rotation
  // ---------------------

  $scope.values = {
    number: _.random(1, 6)
  }; // ---------------------
  // Routing checks
  //  Events can be found: https://github.com/angular-ui/ui-router/wiki#state-change-events
  // ---------------------

  $scope.$state = $state;
  VuexStore.commit('setShowSwitchLanguage', Config.languages && Config.languages.length > 1); // just need this temporarily until the templates that rely on this are ported

  $rootScope.showSwitchLanguage = VuexStore.state.AppStore.showSwitchLanguage;

  $rootScope.switchLanguage = function () {
    if (localStorage.getItem('currentLanguage') !== 'en') {
      localStorage.setItem('currentLanguage', 'en');
      VuexStore.commit('setIsSpanish', false);
      $window.location.reload();
    } else {
      localStorage.setItem('currentLanguage', 'es');
      VuexStore.commit('setIsSpanish', true);
      $window.location.reload();
    }
  };

  VueEventTransmitter.$on('switch-language', function () {
    $rootScope.switchLanguage();
  });

  if (localStorage.getItem('currentLanguage') == 'es') {
    VuexStore.commit('setIsSpanish', true);
  } else {
    VuexStore.commit('setIsSpanish', false);
  } // this is awk but we need this hack to make index.html get our stuff until we port that to vue at the very end


  $rootScope.isSpanish = VuexStore.state.AppStore.isSpanish; // Log errors for missing states. These are like 404 pages
  // but we don't get the luxury of the error being logged on the server
  // NewRelic and other observing plugins should handle notification of this
  // error to the server or analytics engines

  $rootScope.$on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
    $log.error('Unable to find state:', {
      unfoundState: unfoundState,
      fromState: fromState,
      fromParams: fromParams
    });
  });
  $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
    $log.error('Error changing state', {
      toState: toState,
      toParams: toParams,
      fromState: fromState,
      fromParams: fromParams,
      error: error
    });
  });
  $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
    // when we change a state, cycle the values
    $scope.values.number = _.random(1, 6); // set to default container

    $rootScope.newContent = false; // we want our authentication to fail secured. If you want
    // to allow state to be accessible without an authed user, apply the
    // correct authNotRequired data field

    if (!(toState.data && toState.data.authNotRequired) && !AuthService.hasAccess() && toState.name !== 'app.default') {
      $log.info('Currently the user is not authed and we are going to a state that requires access', toState.name);

      var goToDefault = function goToDefault() {
        if (!_authChecked) {
          _returnState = toState.name;
          _returnStateParams = toParams;
        }

        event.preventDefault();
        $state.go('app.default');
      };

      if (!toParams.meta) {
        goToDefault();
      } else {
        PatientUsersService.retrieveMetaInformation(toParams.meta).then(function (resp) {
          if (resp.data && resp.data.isMyChartSSOOnlyUser) {
            finishRegistration(resp.data.data).then(function () {
              _returnStateParams.meta = undefined;
              $state.go(toState.name ? toState.name : 'app.home', toParams);
            });
          } else {
            goToDefault();
          }
        }).catch(function () {
          $log.error('Error collecting user information from meta token');
          goToDefault();
        });
      }
    }

    NavService.close(); // handle scrolling on page transitioning

    if (toState && !toState.noScroll) {
      smoothScroll(document.body, {
        duration: 400
      });
    } // we have to handle initialization of a cci user here
    // so we can redirect them to the correct location when they
    // start this process


    if (toState.name === 'app.default.cci') {
      // since we don't have access to params we need to get the
      // pubId oursevles
      event.preventDefault();
      BillsService.getCCIBill(Url2ObjService.parse($window.location.hash.slice(2), toState.url).pubId).then(function () {
        $state.go('app.bill-summary');
      }).catch(function () {
        $state.go('app.default');
      });
    }
  }); // handle google analytics updates

  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    VueEventTransmitter.$emit('$stateChangeSuccess', toState, toParams);
    VuexStore.commit('setCurrentState', toState.name);

    if ($state.current) {
      if ($state.current.name.indexOf('-payment') === -1) {
        VuexStore.commit('setCurrentPaymentData', null);
      }

      VuexStore.commit('setStateObject', {
        current: $state.current,
        params: $state.params,
        previous: $state.previous
      });
    }

    if (window._gaq && _appStateSettled) {
      window._gaq.push(['_trackPageview', toState.url]);
    }

    if (toState.name === 'app.default.demoSSO' || toState.name === 'app.default.MyChartSSO' || toState.name === 'app.default.MyChartSSO_EHRGW') {// Dont hide the loading indicator, we're going to another state momentarily and we don't want the landing page to flash
    } else {
      VuexStore.commit('setShowLoading', false);
    } // route based global ui change
    // this helps us decide in nested states
    // if we should have the full white background container
    // or allow the content to fill itself


    $scope.fillContent = toState.data && toState.data.fillContentContainer;
  });
  VueEventTransmitter.$on('go-to-state', function (e) {
    $state.go(e.state, e.params, e.routeParams);
  });
  VueEventTransmitter.$on('redirect:withCurrentState', function (options) {
    options.context.stateGo = {
      to: $state.current.name,
      toParams: $stateParams
    };
    options.context.goToCurrentStateWithCurrentParams = undefined;
    VueEventTransmitter.$emit('redirect:tab', options);
  });
  VueEventTransmitter.$on('require-authed-user', function (params, successCallback, errCallback) {
    var promise = AuthService.requireAuthedUser(params);

    if (successCallback) {
      promise = promise.then(function (user) {
        successCallback(user);
      });
    }

    if (errCallback) {
      promise = promise.catch(function () {
        errCallback();
      });
    }
  });
  VueEventTransmitter.$on('unauthenticate-user', function (showModal) {
    AuthService.unauthenticateUser(showModal);
  });
  VueEventTransmitter.$on('linkedAccountService:fetchUnverified', function (forceRefresh) {
    LinkedAccountsService.fetchUnverified(forceRefresh);
  });
  $rootScope.notificationBannerDismissed = false;

  $rootScope.dismissNotificationBanner = function () {
    $rootScope.notificationBannerDismissed = true;
  };

  $rootScope.shouldShowNotificationBanner = function () {
    return ['app.home', 'app.home.accounts-summary', 'app.home.accounts-summary.account-details'].includes($state.current.name) && !$rootScope.notificationBannerDismissed && VuexStore.state.AppStore.visibleNotificationBanner;
  }; // ---------------------
  // Initializing the App State
  // ---------------------
  // On load we need to check to see if we have
  // a currently logged in user and bring it into memory
  // TODO: figure out what we are going to do with initial load
  // and this returning asynchronously


  AuthService.fetchAuthenticatedUser().then(function () {
    var bdToken, ebillShc, unverifedEbillScode, verifyToken, verifyPatientUserId, verifyEmail, patientUser, verifyCode, verifyPhone;
    $log.log('Intial Auth fetch returned, this user is already authenticated', _returnState ? 'returning to ' + _returnState : ''); // TODO: DEV-5520 we should investigate handling this
    // more elegantly

    if ($state.is('app.default')) {
      // extract the meta param, but don't pass it along to return state
      var meta;

      if (_returnStateParams.meta) {
        meta = _returnStateParams.meta;
        _returnStateParams.meta = undefined;
      }

      $state.go(_returnState ? _returnState : 'app.home', _returnStateParams), {
        location: 'replace'
      };

      if (meta) {
        PatientUsersService.retrieveMetaInformation(meta).then(function (resp) {
          if (resp.data && resp.data.isMyChartSSOOnlyUser) {
            finishRegistration(resp.data.data);
          }
        }).catch(function () {
          $log.error('Error collecting user information from meta token');
        });
      } // reset these values


      _returnState = null;
      _returnStateParams = null;
    } else if ($state.is('app.default.bd') && $state.params.token) {
      bdToken = $state.params.token; // backdoor login requested but we currently have a user
      // that is signed in

      AuthService.unauthenticateUser().then(function () {
        return PatientUsersService.bdLogin(bdToken);
      }).then(function () {
        $state.go('app.home');
      }).catch(function () {
        $state.go('app.default');
      });
    } else if ($state.is('app.default.demoSSO') && $state.params.env && $state.params.token) {
      // demo sso login requested but we currently have a user
      // that is signed in
      AuthService.unauthenticateUser().then(function () {
        return PatientUsersService.demoSSO($state.params.token);
      }).then(function () {
        VuexStore.commit('setShowSSOHeader', true);

        if ($state.params.env === 'faetna') {
          VuexStore.commit('setFriendlySSOEnvName', 'My Aetna Partner Portal');
        } else if ($state.params.env === 'fepic') {
          VuexStore.commit('setFriendlySSOEnvName', 'MyChart');
        }

        VuexStore.commit('setShowLoading', true);
        $state.go('app.home');
      }).catch(function () {
        $state.go('app.default');
      });
    } else if ($state.is('app.default.MyChartSSO') && $state.params.token || $state.is('app.default.MyChartSSO_EHRGW') && $state.params.session) {
      var params = {};

      if ($state.is('app.default.MyChartSSO_EHRGW')) {
        params.source = 'ehrgw';
        params.token = $state.params.session;
      } else {
        params.source = 'valet';
        params.token = $state.params.token;
      } // sign out any signed in user and then mychart sso them


      AuthService.unauthenticateUser().then(function () {
        return PatientUsersService.MyChartSSO(params);
      }).then(function (data) {
        if (data.error) {
          if (data.error === ErrorsService.errors.INVALID_TOKEN) {
            $log.error('Unable to initiate MyChartSSO with token ' + $state.params.token);
            VueEventTransmitter.$emit('simpleModal:showPrompt', {
              header: $filter('translate')('myChartSSO.error.invalidToken'),
              subcontent: $filter('translate')('myChartSSO.error.body'),
              intent: 'error',
              actions: [{
                label: $filter('translate')('myChartSSO.error.backToMyChart'),
                clickHandler: function clickHandler() {
                  $scope.returnToReferrer();
                }
              }]
            });
            $state.go('app.default');
          }
        } else {
          if (data.redirectTo) {
            $scope.goToUrl(data.redirectTo);
          }

          if (PatientUsersService.getCurrentUser()) {
            // if user returned, complete SSO
            if (VuexStore.state.AppStore.initialHistoryLength > 1) {
              VuexStore.commit('setShowSSOHeader', true);
              VuexStore.commit('setFriendlySSOEnvName', 'MyChart');
            }

            VuexStore.commit('setShowLoading', true);
            $state.go('app.home', null, {
              location: 'replace'
            });
          } else {
            // if no user returned, enter initial MyChart SSO entry flow
            if (data.createNewFlow) {
              $state.go('app.default', null, {
                location: 'replace'
              });
              VueEventTransmitter.$emit('myChartSSO:showCheckEmail', data.source, data.token, data.metadata.firstName, data.metadata.lastName);
            } else {
              $state.go('app.default');
            }
          }
        }
      }).catch(function (err) {
        $log.error('Unable to initiate MyChartSSO with token ' + params.token + ' from source ' + params.source, err);
        VueEventTransmitter.$emit('simpleModal:showPrompt', {
          header: $filter('translate')('myChartSSO.error.header'),
          subcontent: $filter('translate')('myChartSSO.error.body'),
          intent: 'error',
          actions: [{
            label: $filter('translate')('myChartSSO.error.backToMyChart'),
            clickHandler: function clickHandler() {
              $scope.returnToReferrer();
            }
          }]
        });
        $state.go('app.default');
      });
    } else if ($state.is('app.default.ebill')) {
      var theToken = $state.params.shc;
      ebillShc = theToken;
      unverifedEbillScode = $state.params.verified === '0' ? ebillShc : null;

      var completeEbillFlow = function completeEbillFlow() {
        var token = theToken;
        VuexStore.commit('setShowLoading', false); // Attempt to find the bill associated with this user

        return BillsService.getAccountBill(ebillShc).then(function () {
          if (token) {
            setTimeout(function () {
              BillsService.markOpened(token);
            }, NUM_MILLISECONDS_BEFORE_EBILL_OPENED);
          }

          _handleSuccessfulGetAccountBill();
        }).catch(function (resp) {
          // So we have attempted to load this ebill from the
          // currently logged in users account. We are going to make
          // the assumption that the securecode not found error is because
          // it is not with the user, and not that it is invalid. So when
          // this happens, we will log the user out and attempt to log in the
          // user who the link is for.
          // The compromise here is that, if a user is logged in and changes
          // the shc to an invalid one, it will log them out.
          if (ErrorsService.resolve(resp) === ErrorsService.errors.SECURECODE_NOT_FOUND) {
            $log.error('We were unable to load the ebill for the signed in users account.'); // log user out and ask for a new user

            return AuthService.unauthenticateUser().then(function () {
              $log.info('Logged user now get ebill user');
              return AuthService.requireAuthedUser({
                openSection: 'login'
              });
            }).then(function () {
              // try one last time to get the bill for the
              // user
              return BillsService.getAccountBill(ebillShc);
            }).then(function () {
              _handleSuccessfulGetAccountBill();
            });
          } // we failed to do a good bill lookup and can't mitigate


          return $q.reject();
        }).catch(function (resp) {
          if (ErrorsService.resolve(resp) === ErrorsService.errors.SECURECODE_NOT_FOUND) {
            // we tried all means by which to find bill by scode
            // we are adding the check and verify flow here as
            // to not undermine the above logic for why we might
            // need to log the user out to verify it was the right
            // logged in user state for the browser being used
            if (unverifedEbillScode) {
              $state.go('app.home');
              VueEventTransmitter.$emit('accountVerification:prompt:proceedToPay', unverifedEbillScode);
            }
          } else {
            $log.error('Unable to get the ebill');
            $state.go('app.home');
          }
        });
      };

      if ($state.params.meta) {
        PatientUsersService.retrieveMetaInformation($state.params.meta).then(function (resp) {
          if (resp.data && resp.data.isMyChartSSOOnlyUser) {
            $state.go('app.default');
            VueEventTransmitter.$emit('myChartSSO:showFinishRegistration', resp.data.data, completeEbillFlow);
          } else {
            completeEbillFlow();
          }
        }).catch(function () {
          completeEbillFlow();
        });
      } else {
        PatientUsersService.checkPatientUserStatus($state.params.shc, 'BILL').then(function (resp) {
          if (resp.data && resp.data.isMyChartSSOOnlyUser) {
            $state.go('app.default');
            VueEventTransmitter.$emit('myChartSSO:showFinishRegistration', resp.data.data, completeEbillFlow);
          } else {
            completeEbillFlow();
          }
        }).catch(function () {
          completeEbillFlow();
        });
      }
    } else if ($state.is('app.default.firstBill')) {
      var firstBillToken = $state.params.token;
      BillsService.findAuthOptions(firstBillToken).then(function (resp) {
        VuexStore.commit('setShowLoading', false);
        VueEventTransmitter.$emit('firstCommVerification:prompt', {
          'type': 'bill',
          'options': resp,
          'token': firstBillToken
        });
        setTimeout(function () {
          BillsService.markOpened(firstBillToken);
        }, NUM_MILLISECONDS_BEFORE_EBILL_OPENED);
      }).catch(function () {
        Compass.capture.failure('first-bill', 'token', firstBillToken);
        $state.go('app.home');
      });
    } else if ($state.is('app.default.estimate')) {
      var token = $state.params.token;

      var completeEstimateFlow = function completeEstimateFlow() {
        VuexStore.commit('setShowLoading', false); // Attempt to find the estimate associated with this user

        return EstimatesService.getAccountEstimate(token).then(function (estimate) {
          setTimeout(function () {
            EstimatesService.markOpened(token);
          }, NUM_MILLISECONDS_BEFORE_EBILL_OPENED);
          $state.go('app.verify-estimate', {
            id: estimate.providerDetails.providerId,
            estimateId: estimate.estimateId
          });
        }).catch(function (resp) {
          // So we have attempted to load this estimate from the
          // currently logged in users account. We are going to make
          // the assumption that the estimate not found error is because
          // it is not with the user, and not that it is invalid. So when
          // this happens, we will log the user out and attempt to log in the
          // user who the link is for.
          // The compromise here is that, if a user is logged in and changes
          // the estimate to an invalid one, it will log them out.
          if (ErrorsService.resolve(resp) === ErrorsService.errors.ESTIMATE_NOT_FOUND) {
            $log.error('We were unable to load the estimate for the signed in users account.'); // log user out and ask for a new user

            return AuthService.unauthenticateUser().then(function () {
              $log.info('Logged user now get estimate user');
              return AuthService.requireAuthedUser({
                openSection: 'login'
              });
            }).then(function () {
              // try one last time to get the estimate for the
              // user
              return EstimatesService.getAccountEstimate(token);
            }).then(function (estimate) {
              $state.go('app.verify-estimate', {
                id: estimate.providerDetails.providerId,
                estimateId: estimate.estimateId
              });
            });
          } // we failed to do a good estimate lookup and can't mitigate


          return $q.reject();
        }).catch(function (resp) {
          if (ErrorsService.resolve(resp) === ErrorsService.errors.ESTIMATE_NOT_FOUND) {
            // we tried all means by which to find estimate
            // we are adding the check and verify flow here as
            // to not undermine the above logic for why we might
            // need to log the user out to verify it was the right
            // logged in user state for the browser being used
            $state.go('app.home');
          } else {
            $log.error('Unable to get the estimate');
            $state.go('app.home');
          }
        });
      };

      PatientUsersService.checkPatientUserStatus(token, 'ESTIMATE').then(function (resp) {
        if (resp.data && resp.data.isMyChartSSOOnlyUser) {
          $state.go('app.default');
          VueEventTransmitter.$emit('myChartSSO:showFinishRegistration', resp.data.data, completeEstimateFlow);
        } else {
          completeEstimateFlow();
        }
      }).catch(function () {
        completeEstimateFlow();
      });
    } else if ($state.is('app.default.firstEstimate')) {
      var firstEstimateToken = $state.params.token;
      EstimatesService.findAuthOptions(firstEstimateToken).then(function (resp) {
        VuexStore.commit('setShowLoading', false);
        VueEventTransmitter.$emit('firstCommVerification:prompt', {
          'type': 'estimate',
          'options': resp,
          'token': firstEstimateToken
        });
        setTimeout(function () {
          EstimatesService.markOpened(firstEstimateToken);
        }, NUM_MILLISECONDS_BEFORE_EBILL_OPENED);
      }).catch(function () {
        Compass.capture.failure('first-estimate', 'token', '');
        $state.go('app.default');
      });
    } else if ($state.is('app.default.verifyEmail')) {
      verifyToken = $state.params.token;
      verifyPatientUserId = parseInt($state.params.patientUserId, 10);
      verifyEmail = $state.params.email;
      patientUser = PatientUsersService.getCurrentUser();

      if (patientUser.patientUserId !== verifyPatientUserId) {
        // User is trying to verify an account that differs from the logged in user
        // Let's log the user out and try again on login
        AuthService.unauthenticateUser().then(function () {
          VuexStore.commit('setShowLoading', false);
          return AuthService.requireAuthedUser({
            openSection: 'login',
            prefillEmail: verifyEmail,
            verifyToken: verifyToken,
            verifyPatientUserId: verifyPatientUserId
          });
        }).then(function () {
          patientUser = PatientUsersService.getCurrentUser(); // User logged in as the correct user being verified

          if (patientUser.patientUserId === verifyPatientUserId) {
            // Verification was successful or not
            if (patientUser.emailVerified) {
              $log.info('Email has been verified!');
              $state.go('app.emailVerified');
            } else {
              $log.error('Error verifying email');
              $state.go('app.home');
            }
          } else {
            // User logged in as different user :facepalm:
            $log.error('User logged in with email other than the one being verified.');
            $state.go('app.home');
          }
        });
      } else {
        // User is already logged in as the user being verified so call verifyEmail endpoint
        PatientUsersService.verifyEmail(verifyToken, verifyPatientUserId).then(function () {
          $log.info('Email has been verified!');
          $state.go('app.emailVerified');
        }).catch(function () {
          $log.error('Error verifying email');
          $state.go('app.home');
        });
      }
    } else if ($state.is('app.default.verifyPhone')) {
      verifyCode = $state.params.code;
      verifyPatientUserId = parseInt($state.params.patientUserId, 10);
      verifyPhone = $state.params.phoneNumber;
      PatientUsersService.verifyPhone(verifyCode, verifyPatientUserId, verifyPhone).then(function () {
        $log.info('Phone number has been verified!');
        $state.go('app.phoneVerified');
      }).catch(function () {
        $log.error('Error verifying phone number');
        $state.go('app.home');
      });
    } else if ($state.is('app.default.viewNotifications')) {
      var notificationId = $state.params.notificationId;
      $state.go('app.home').then(function () {
        VueEventTransmitter.$emit('notifications:show', notificationId);
      });
    }
  }).catch(function () {
    var ebillShc, unverifedEbillScode, verifyToken, verifyPatientUserId, verifyEmail, patientUser, verifyCode, verifyPhone;

    var getAuthUserPromise = function getAuthUserPromise(paramsObj) {
      if ($state.params.meta) {
        return PatientUsersService.retrieveMetaInformation($state.params.meta).then(function (resp) {
          if (resp.data && resp.data.isMyChartSSOOnlyUser) {
            $state.go('app.default');
            return finishRegistration(resp.data.data);
          }
        }).catch(function () {
          $log.error('Error collecting user information from meta param');
          return AuthService.requireAuthedUser(paramsObj);
        });
      } else {
        return AuthService.requireAuthedUser(paramsObj);
      }
    }; // check to see if the user is trying to
    // backdo


    if ($state.is('app.default.bd') && $state.params.token) {
      // backdoor login requested
      PatientUsersService.bdLogin($state.params.token).then(function () {
        $state.go('app.home');
      }).catch(function () {
        $state.go('app.default');
      });
      return;
    } else if ($state.is('app.default.demoSSO') && $state.params.env && $state.params.token) {
      // demo sso login requested
      PatientUsersService.demoSSO($state.params.token).then(function () {
        VuexStore.commit('setShowSSOHeader', true);

        if ($state.params.env === 'faetna') {
          VuexStore.commit('setFriendlySSOEnvName', 'My Aetna Partner Portal');
        } else if ($state.params.env === 'fepic') {
          VuexStore.commit('setFriendlySSOEnvName', 'MyChart');
        }

        VuexStore.commit('setShowLoading', true);
        $state.go('app.home');
      }).catch(function () {
        $state.go('app.default');
      });
      return;
    } else if ($state.is('app.default.MyChartSSO') && $state.params.token || $state.is('app.default.MyChartSSO_EHRGW') && $state.params.session) {
      // mychart sso requested
      var params = {};

      if ($state.is('app.default.MyChartSSO_EHRGW')) {
        params.source = 'ehrgw';
        params.token = $state.params.session;
      } else {
        params.source = 'valet';
        params.token = $state.params.token;
      }

      PatientUsersService.MyChartSSO(params).then(function (data) {
        if (data.error) {
          if (data.error === ErrorsService.errors.INVALID_TOKEN) {
            $log.error('Unable to initiate MyChartSSO with token ' + $state.params.token);
            VueEventTransmitter.$emit('simpleModal:showPrompt', {
              header: $filter('translate')('myChartSSO.error.invalidToken'),
              subcontent: $filter('translate')('myChartSSO.error.body'),
              intent: 'error',
              actions: [{
                label: $filter('translate')('myChartSSO.error.backToMyChart'),
                clickHandler: function clickHandler() {
                  $scope.returnToReferrer();
                }
              }]
            });
            $state.go('app.default');
          }
        } else {
          if (data.redirectTo) {
            $scope.goToUrl(data.redirectTo);
          }

          if (PatientUsersService.getCurrentUser()) {
            // if user returned, complete SSO
            if (VuexStore.state.AppStore.initialHistoryLength > 1) {
              VuexStore.commit('setShowSSOHeader', true);
              VuexStore.commit('setFriendlySSOEnvName', 'MyChart');
            }

            VuexStore.commit('setShowLoading', true);
            $state.go('app.home', null, {
              location: 'replace'
            });
          } else {
            // if no user returned, enter initial MyChart SSO entry flow
            if (data.createNewFlow) {
              $state.go('app.default', null, {
                location: 'replace'
              });
              VueEventTransmitter.$emit('myChartSSO:showCheckEmail', data.source, data.token, data.metadata.firstName, data.metadata.lastName);
            } else {
              $state.go('app.default');
            }
          }
        }
      }).catch(function (err) {
        $log.error('Unable to initiate MyChartSSO with token ' + params.token + ' from source ' + params.source, err);
        VueEventTransmitter.$emit('simpleModal:showPrompt', {
          header: $filter('translate')('myChartSSO.error.header'),
          subcontent: $filter('translate')('myChartSSO.error.body'),
          intent: 'error',
          actions: [{
            label: $filter('translate')('myChartSSO.error.backToMyChart'),
            clickHandler: function clickHandler() {
              $scope.returnToReferrer();
            }
          }]
        });
        $state.go('app.default');
      });
      return;
    } else if ($state.is('app.default.ebill')) {
      // if the user is not logged in, we need to log
      // them in to get the ebill that is associated with
      // the account'
      var theToken = $state.params.shc;
      ebillShc = $state.params.shc;
      unverifedEbillScode = $state.params.verified === '0' ? ebillShc : null;

      var completeEbillFlow = function completeEbillFlow() {
        var token = theToken;
        VuexStore.commit('setShowLoading', false);
        return AuthService.requireAuthedUser({
          openSection: 'login'
        }).then(function () {
          BillsService.getAccountBill(ebillShc).then(function () {
            if (token) {
              setTimeout(function () {
                BillsService.markOpened(token);
              }, NUM_MILLISECONDS_BEFORE_EBILL_OPENED);
            }

            _handleSuccessfulGetAccountBill();
          }).catch(function (resp) {
            if (ErrorsService.resolve(resp) === ErrorsService.errors.SECURECODE_NOT_FOUND) {
              // we tried all means by which to find bill by scode
              // we are adding the check and verify flow here as
              // to not undermine the above logic for why we might
              // need to log the user out to verify it was the right
              // logged in user state for the browser being used
              if (unverifedEbillScode) {
                $state.go('app.home');
                VueEventTransmitter.$emit('accountVerification:prompt:proceedToPay', unverifedEbillScode);
              }
            } else {
              $log.error('Unable to get the ebill');
              $state.go('app.home');
            }
          });
        }).catch(function () {
          $log.error('Could not log in to get ebill');
          $state.go('app.default');
        });
      };

      if ($state.params.meta) {
        PatientUsersService.retrieveMetaInformation($state.params.meta).then(function (resp) {
          if (resp.data && resp.data.isMyChartSSOOnlyUser) {
            $state.go('app.default');
            VueEventTransmitter.$emit('myChartSSO:showFinishRegistration', resp.data.data, completeEbillFlow);
          } else {
            completeEbillFlow();
          }
        }).catch(function () {
          completeEbillFlow();
        });
      } else {
        PatientUsersService.checkPatientUserStatus($state.params.shc, 'BILL').then(function (resp) {
          if (resp.data && resp.data.isMyChartSSOOnlyUser) {
            $state.go('app.default');
            VueEventTransmitter.$emit('myChartSSO:showFinishRegistration', resp.data.data, completeEbillFlow);
          } else {
            completeEbillFlow();
          }
        }).catch(function () {
          completeEbillFlow();
        });
      }
    } else if ($state.is('app.default.firstBill')) {
      var firstBillToken = $state.params.token;
      BillsService.findAuthOptions(firstBillToken).then(function (resp) {
        VuexStore.commit('setShowLoading', false);
        VueEventTransmitter.$emit('firstCommVerification:prompt', {
          'type': 'bill',
          'options': resp,
          'token': firstBillToken
        });
        setTimeout(function () {
          BillsService.markOpened(firstBillToken);
        }, NUM_MILLISECONDS_BEFORE_EBILL_OPENED);
      }).catch(function () {
        Compass.capture.failure('first-bill', 'token', firstBillToken);
        $state.go('app.default');
      });
    } else if ($state.is('app.default.estimate')) {
      var token = $state.params.token;

      var completeEstimateFlow = function completeEstimateFlow() {
        VuexStore.commit('setShowLoading', false);
        return AuthService.requireAuthedUser({
          openSection: 'login'
        }).then(function () {
          EstimatesService.getAccountEstimate(token).then(function (estimate) {
            setTimeout(function () {
              EstimatesService.markOpened(token);
            }, NUM_MILLISECONDS_BEFORE_EBILL_OPENED);
            $state.go('app.verify-estimate', {
              id: estimate.providerDetails.providerId,
              estimateId: estimate.estimateId
            });
          }).catch(function (resp) {
            if (ErrorsService.resolve(resp) === ErrorsService.errors.ESTIMATE_NOT_FOUND) {
              // we tried all means by which to find estimate
              // we are adding the check and verify flow here as
              // to not undermine the above logic for why we might
              // need to log the user out to verify it was the right
              // logged in user state for the browser being used
              $state.go('app.home');
            } else {
              $log.error('Unable to get the estimate');
              $state.go('app.home');
            }
          });
        }).catch(function () {
          $log.error('Could not log in to get estimate');
          $state.go('app.default');
        });
      };

      PatientUsersService.checkPatientUserStatus(token, 'ESTIMATE').then(function (resp) {
        if (resp.data && resp.data.isMyChartSSOOnlyUser) {
          $state.go('app.default');
          VueEventTransmitter.$emit('myChartSSO:showFinishRegistration', resp.data.data, completeEstimateFlow);
        } else {
          completeEstimateFlow();
        }
      }).catch(function () {
        completeEstimateFlow();
      });
    } else if ($state.is('app.default.firstEstimate')) {
      var firstEstimateToken = $state.params.token;
      EstimatesService.findAuthOptions(firstEstimateToken).then(function (resp) {
        VuexStore.commit('setShowLoading', false);
        VueEventTransmitter.$emit('firstCommVerification:prompt', {
          'type': 'estimate',
          'options': resp,
          'token': firstEstimateToken
        });
        setTimeout(function () {
          EstimatesService.markOpened(firstEstimateToken);
        }, NUM_MILLISECONDS_BEFORE_EBILL_OPENED);
      }).catch(function () {
        Compass.capture.failure('first-estimate', 'token', '');
        $state.go('app.default');
      });
    } else if ($state.is('app.default.verifyEmail')) {
      verifyToken = $state.params.token;
      verifyPatientUserId = parseInt($state.params.patientUserId, 10);
      verifyEmail = $state.params.email; // User is not logged in, let's try to verify the email on login

      getAuthUserPromise({
        openSection: 'login',
        prefillEmail: verifyEmail,
        verifyToken: verifyToken,
        verifyPatientUserId: verifyPatientUserId
      }).then(function () {
        patientUser = PatientUsersService.getCurrentUser(); // User logged in as the correct user being verified

        if (patientUser.patientUserId === verifyPatientUserId) {
          // Verification was successful or not
          if (patientUser.emailVerified) {
            $log.info('Email has been verified!');
            $state.go('app.emailVerified');
          } else {
            $log.error('Error verifying email');
            $state.go('app.home');
          }
        } else {
          // User logged in as different user :facepalm:
          $log.error('User logged in with email other than the one being verified.');
          $state.go('app.home');
        }
      }).catch(function () {
        $log.error('Could not log in to verify email');
        $state.go('app.default');
      });
    } else if ($state.is('app.default.verifyPhone')) {
      verifyCode = $state.params.code;
      verifyPatientUserId = parseInt($state.params.patientUserId, 10);
      verifyPhone = $state.params.phoneNumber;
      PatientUsersService.verifyPhone(verifyCode, verifyPatientUserId, verifyPhone).then(function () {
        $log.info('Phone number has been verified!');
        $state.go('app.phoneVerified');
      }).catch(function () {
        $log.error('Error verifying phone number');
        $state.go('app.home');
      });
    } else if ($state.is('app.default.viewNotifications')) {
      AuthService.requireAuthedUser({
        openSection: 'login'
      }).then(function () {
        var notificationId = $state.params.notificationId;
        $state.go('app.home').then(function () {
          VueEventTransmitter.$emit('notifications:show', notificationId);
        });
      });
    } else {
      VuexStore.commit('setShowLoading', false);
    } // we make the assumption that we are on app.default state
    // for deep linking if we have a return state and we
    // will attempt to get an authed user and redirect back


    if (_returnState) {
      $log.log('Attempting deep link login access');
      getAuthUserPromise({
        openSection: 'login'
      }).then(function () {
        $state.go(_returnState ? _returnState : 'app.home', _returnStateParams, {
          location: 'replace'
        }); // reset thes values

        _returnState = null;
        _returnStateParams = null;
      });
    }
  }).finally(function () {
    // AngularJS reactivity for components relying on vuex does not work unless we do this
    $interval(function () {}, 1);
    _authChecked = true; // After we figure out the user's state and handle
    // redirection, we will allow for a little bit of
    // time to account for the redirection this promise
    // chain may also contain.

    $timeout(function () {
      _appStateSettled = true;
    }, 50);
    AutoLogoutService.start(false);
  });

  $scope.goToUrl = function (url) {
    $window.location.href = url;
  };

  $scope.back = function () {
    $scope.goToUrl('/');
  };

  $scope.returnToReferrer = function () {
    $window.history.go(VuexStore.state.AppStore.initialHistoryLength - $window.history.length - 1);
  };
}]);